module.exports = __webpack_public_path__ + "img/zhAward-1.552e46b2.png";